<template>
    <DefaultLayout header="wizard" :footer="false">
        <ApplyWizard />
    </DefaultLayout>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        territory: function () {
            return window.TERRITORY
        },
    },
}
</script>
